import React from "react";
import "./TagInput.scss";

import { MentionsInput, Mention, SuggestionDataItem } from 'react-mentions'
import VarsModel from "../../Models/Variables/VarsModel.Model";

export interface TagInputTag  {id:string, display:string}
export enum TagInputType {
    Normal = "tagInputNormal",
    SingleLine = "tagInputSingleLine",
    Bubble = "tagInputBubble",
    NoBorder = "tagInputNoBorder"
  }
  
  interface InputProps {
    value?:string;

    overrideVariables?:TagInputTag[];
    mergeVariables?:TagInputTag[];
    type?:TagInputType;
    name?:string;
    disabled?:boolean;
    readOnly?:boolean

    placeholder?:string; 
    onChange?(event:React.ChangeEvent<HTMLInputElement>):void;
    onSet?(value: React.SetStateAction<string>, name?:string):void; 
    onReturnPressed?():void;

    onBlur?():void;
    onFocus?():void;

    // inputProvider?(id, display):string 

  }
  
  interface State {
    isFocused:boolean 
  }

  export function TagInput(props:InputProps) {
    return <TagInputInternal {...props}  />
  }


  

  class TagInputInternal extends React.Component<InputProps,State> {

    

    
    private inputRef = React.createRef<any>()

    constructor(props:InputProps) {
      super(props)
      this.state = {isFocused: false}
      this.onKeyDown = this.onKeyDown.bind(this)
      this.onChange = this.onChange.bind(this)
      this.renderTagSuggestion = this.renderTagSuggestion.bind(this)
      this.onFocus = this.onFocus.bind(this)
      this.onBlur = this.onBlur.bind(this)

    }
    componentDidMount() {
      // if (this.props.value) {
      //   const value = this.props.value; 
      //   if ((value.indexOf("#*") > -1) && (value.indexOf("[") < 0)) {
          
      //   }

      // }
    }


    focus() { if (this.inputRef && this.inputRef.current) { this.inputRef.current.focus(); } }
    onKeyDown(e:React.KeyboardEvent){  if(e.keyCode == 13  && this.props.onReturnPressed){ this.props.onReturnPressed(); } }
    onChange(event:any) {
      if  (this.props.onChange) {
        if (this.props.name) { event.target.name = this.props.name; }

        this.props.onChange(event); 
      }
      if  (this.props.onSet) { this.props.onSet(event.target.value, this.props.name); }
    }
    // dataForVariables() {
          
      

    //     if (Array.isArray(variables)) {
    //       return variables;
    //     }
    //     let data = []
        
    //     if (variables) {
    //         for (const key in variables) {
    //             if (Object.prototype.hasOwnProperty.call(variables, key)) {
    //                 if (!variables[key].hidden) {
    //                     data.push({id: key, display: variables[key].name})
    //                 }
    //             }
    //         }
    //     }

    //     return data;
    // }

    renderTagSuggestion(entry:SuggestionDataItem) {
        
        return  <span>{entry.display}</span>
    }
  

    onFocus() {
      if (this.props.onFocus) {
        this.props.onFocus();
      }
      this.setState({isFocused: true})
    }
    onBlur() {
      if (this.props.onBlur) {
        this.props.onBlur();
      }
      this.setState({isFocused: false})
    }

    render() {
        const {type , name,disabled,readOnly, onBlur, onFocus,placeholder } = this.props; 
        
        const {isFocused} = this.state; 
        let className = isFocused ? "TagInputWrapperLocal isFocused " :"TagInputWrapperLocal "; 
        if (type) { className += " " + type; } else { className += " " + TagInputType.Normal; }
        if (disabled) { className += " disabled"; }

        return <div className={className}> <MentionsInput 
        disabled={disabled}
                    value={this.props.value} 
                    onChange={this.onChange}
                    inputRef={this.inputRef}
                    singleLine={type === TagInputType.SingleLine}
                    placeholder={placeholder}
                    className="TagInput"
                    autoComplete="off"
                    readOnly={readOnly}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                    name={name}
                    >

        <Mention
        trigger="#"
        data={ VarsModel.getTagInputVariables()  }
        renderSuggestion={this.renderTagSuggestion}
        markup="#*__id__*#"

        displayTransform={(id, display) =>  VarsModel.inputProvider(id, display) }
    
          
        />


    </MentionsInput>
    </div>
    }
 }